// extracted by mini-css-extract-plugin
export var active = "style-module--active--475b5";
export var activeContent = "style-module--activeContent--9dc09";
export var close = "style-module--close--fc550";
export var cnumber = "style-module--cnumber--7c91a";
export var firstLine = "style-module--firstLine--bbbca";
export var link = "style-module--link--030e1";
export var persona = "style-module--persona--ed875";
export var personas = "style-module--personas--0e52e";
export var use = "style-module--use--c4b82";